import React from 'react';
import { Link } from 'react-router-dom';
import { challengeSummarySurfaceClass, sectionLabelClass } from './challengeWireFormStyles';
import { formatCommunityResultDisplay } from '../../utils/communityResultDisplay';
import { leaderboardRankEmoji } from '../../utils/communityLeaderboardDisplay';
import { buildChallengeScheduleLine } from '../../utils/challengeSummaryDisplay';
import ChallengeStatusIndicator from './ChallengeStatusIndicator';

export default function CommunityChallengeListCard({ challenge }) {
	const scheduleLine = buildChallengeScheduleLine(challenge.starts_on, challenge.ends_on);
	const preview = challenge.leaderboard_preview || [];

	return (
		<article
			className={`flex h-full flex-col overflow-hidden rounded-xl border border-gray-200 dark:border-dark-border ${challengeSummarySurfaceClass}`}
		>
			<div className="flex-1 p-4 sm:p-5 space-y-3">
				<div className="flex items-start justify-between gap-3">
					<p className={sectionLabelClass}>Community Challenge</p>
					<ChallengeStatusIndicator status={challenge.status} />
				</div>
				<p className="text-sm text-gray-600 dark:text-gray-400">
					<strong className="text-gray-900 dark:text-dark-text">{challenge.creator_name}</strong> posted
					to your network
				</p>
				<p className="text-base font-semibold text-gray-900 dark:text-dark-text">{challenge.title}</p>
				{scheduleLine && <p className="text-sm text-gray-600 dark:text-gray-400">{scheduleLine}</p>}
				<p className="text-sm text-gray-600 dark:text-gray-400">
					{challenge.joined_count} joined
					{preview.length > 0 &&
						preview.map((entry) => (
							<span key={entry.rank}>
								{' · '}
								<span aria-label={`Rank ${entry.rank}`}>
									{leaderboardRankEmoji(entry.rank)}
								</span>{' '}
								{entry.profile_name}{' '}
								{formatCommunityResultDisplay(entry.result_display)}
							</span>
						))}
				</p>
			</div>
			<footer className="border-t border-gray-100 dark:border-dark-border bg-gray-50 dark:bg-black px-4 py-3">
				<Link
					to={`/community-challenges/${challenge.id}`}
					className="block w-full rounded-lg bg-blue-600 py-2 text-center text-sm font-medium text-white hover:bg-blue-700"
				>
					View leaderboard
				</Link>
			</footer>
		</article>
	);
}
